import { useState } from 'react';
import { DEFAULT_COUNTRY_CODE } from '../Constants';

/**
 * localStorage key for cached phone country code
 * Exported for external access if needed (e.g., clearing cache on logout)
 */
export const COUNTRY_CODE_STORAGE_KEY = 'userPhoneCountryCode';

/**
 * Hook for managing cached phone country code in localStorage
 * Persists user's country selection across sessions with no expiration
 *
 * TODO: Replace with useGeoCountry hook (ipinfo.io) for auto-detection
 *
 * @returns {object} { countryCode, setCountryCode }
 * @example
 * const { countryCode, setCountryCode } = useCountryCodeCache();
 * // countryCode: current cached value or DEFAULT_COUNTRY_CODE
 * // setCountryCode: function to update both state and localStorage
 */
export const useCountryCodeCache = () => {
    // Lazy initial state - only reads localStorage once on mount
    const [countryCode, setCountryCodeState] = useState(() => {
        return localStorage.getItem(COUNTRY_CODE_STORAGE_KEY) || DEFAULT_COUNTRY_CODE;
    });

    /**
     * Updates country code in both React state and localStorage
     * @param {string} code - Two-letter country code (e.g., 'IL', 'US')
     */
    const setCountryCode = (code) => {
        if (code) {
            localStorage.setItem(COUNTRY_CODE_STORAGE_KEY, code);
            setCountryCodeState(code);
        }
    };

    return { countryCode, setCountryCode };
};
